import * as Yup from "yup";

export const getValidationSchemas = (t) => [
    Yup.object().shape({
        property_type_id: Yup.string().required(t("AddProperties.propertyRequired")),
    }),
    Yup.object().shape({
        country: Yup.string()
            .required(t("AddProperties.countryRequired"))
            .min(3)
            .max(40)
            .label(t("AddProperties.country")),
        zone_id: Yup.string().required(t("AddProperties.zoneRequired")),
        street_address: Yup.string()
            .required(t("AddProperties.streetRequired"))
            .min(3)
            .max(200)
            .label(t("AddProperties.streetAddress")),
        flat_suite: Yup.string()
            .required(t("AddProperties.unitsRequired"))
            .max(10, t("AddProperties.charactersValidation"))
            .label(`${t("AddProperties.flat"), t("AddProperties.suite"), t("AddProperties.unit")}`),

        latitude: Yup.string(),
        longitude: Yup.string(),
        city_id: Yup.string().required(t("AddProperties.cityRequired")),
    }),
    Yup.object().shape({
        short_description: Yup.string()
            .required(t("AddProperties.shortDescription"))
            .min(10)
            .max(75)
            .label(t("AddProperties.shortDescription")),
        short_description_hebrew: Yup.string()
            .required(t("AddProperties.ShortRequired"))
            .min(10)
            .max(75)
            .label(t("AddProperties.shortDescription")),
        long_description: Yup.string()
            .min(250)
            .label(t("AddProperties.longDescription")),
        long_description_hebrew: Yup.string()
            .min(250)
            .required(t("AddProperties.longDesforHebrew"))
            .label(t("AddProperties.longDescription")),
    }),
    Yup.object().shape({
        room_type: Yup.string().required(t("AddProperties.roomRequired")),
        price_for_weekends: Yup.number(t("AddProperties.EnterNumber")).required(
            t("AddProperties.PriceWeekends")
        ),
        weekend_discounted_price: Yup.number(t("AddProperties.EnterNumber")),
        price_for_weekdays: Yup.number(t("AddProperties.EnterNumber"))
            .min(1)
            .required(t("AddProperties.DiscountedPrice")),
        weekdays_discounted_price: Yup.number(t("AddProperties.EnterNumber")),
        rooms: Yup.array().of(
            Yup.object().shape({
                numberOfBeds: Yup.number(t("AddProperties.EnterNumber"))
                    .required(t("AddProperties.NumberValidation"))
                    .min(1, t("AddProperties.MinimumNumberBeds"))
                    .label(t("AddProperties.NumberBeds")),

                size: Yup.number()
                    .required(t("AddProperties.SizeRequired"))
                    .min(1, t("AddProperties.minimumNumberSize"))
                    .label(t("AddProperties.ValidSize")),

                adults: Yup.number()
                    .min(1, t("AddProperties.adultsValidate"))
                    .required(t("AddProperties.adultsIsRequired")),
                children: Yup.number(),
                pets: Yup.number(),
            })
        ),
    }),
    Yup.object().shape({
        facilities: Yup.array().min(1, t("AddProperties.facilitesSelected")),
    }),
];
